export const environment = {
    production: true,
    localStorageKey: 'Jupiter_LS_Copeia_Key',//local storage key
    APIUrl: "/admin",
    BasePath: "jupiter",
    AllowPushNotification: true
};
